import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IndexesDataRoutingModule } from './indexes-data-routing.module';
import { IndexesDataComponent } from './indexes-data.component';
import { SharedModule } from '../../shared/shared.module';
import { Ng2SmartTableModule } from 'ng2-smart-table';
import { UpdateCitiationComponent } from './update-citiation.component';

@NgModule({
  declarations: [IndexesDataComponent, UpdateCitiationComponent],
  imports: [
    CommonModule,
    IndexesDataRoutingModule,
    SharedModule,
    FormsModule,
    Ng2SmartTableModule,
  ],
})
export class IndexesDataModule {}
